import { render, staticRenderFns } from "./eduLearning.vue?vue&type=template&id=1b194a6f&scoped=true"
import script from "./eduLearning.vue?vue&type=script&lang=js"
export * from "./eduLearning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b194a6f",
  null
  
)

export default component.exports